module.exports = __webpack_public_path__ + "img/posttesticon_0.5b6c2abc.png";